import { render, staticRenderFns } from "./initialFormCreation.vue?vue&type=template&id=7a97ba8e&"
import script from "./initialFormCreation.vue?vue&type=script&lang=js&"
export * from "./initialFormCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports